$(function() {
    $('.filter-button').on('click', function(e) {
        e.preventDefault();

        const $this = $(this);
        const $wrapper = $this.closest('.cards-filter');
        const target = $this.data('filter');
        
        if ($this.hasClass('active')) {
            return false;
        }

        //Remove active from all filter buttons
        $wrapper.find('.filter-button').removeClass('active');
        
        //Hide all filter content
        $wrapper.find('.filter-content').removeClass('visible-filter-content');

        //Add class to filter button
        $this.addClass('active');
        
        //Add class to filter content
        console.log($('.filter-content[data-filter='+ target +']', $wrapper));
        $('.filter-content[data-filter='+ target +']', $wrapper)
            .addClass('visible-filter-content');
    })
})
